<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M20.0131 3H3.54254C2.56607 3 1.77783 3.82281 1.77783 4.84211V17.1228C1.77783 18.1421 2.56607 18.9649 3.54254 18.9649H4.13077V24L9.64842 18.9649H20.0131C20.9896 18.9649 21.7778 18.1421 21.7778 17.1228V4.84211C21.7778 3.82281 20.9896 3 20.0131 3ZM20.6014 17.1228C20.6014 17.4544 20.3425 17.7368 20.0131 17.7368H9.20136L5.30724 21.2982V17.7368H3.54254C3.21313 17.7368 2.9543 17.4544 2.9543 17.1228V4.84211C2.9543 4.51053 3.21313 4.22807 3.54254 4.22807H20.0131C20.3425 4.22807 20.6014 4.51053 20.6014 4.84211V17.1228ZM5.30724 6.68421H18.2484V7.91228H5.30724V6.68421ZM5.30724 9.14035H18.2484V10.3684H5.30724V9.14035ZM5.30724 11.5965H12.3661V12.8246H5.30724V11.5965Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
